import {Component, EventEmitter, Input, Output} from '@angular/core';
import {MessageSeverity} from "../message.model";
import { UserPasswordAction } from '../../../../states/user/user-password.action';
import { Store } from '@ngxs/store';
import { NgStyle, NgClass } from '@angular/common';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'cp-message-design-b-small',
    template: `
    <div class="MessageDesignBSmall-container"
      [ngStyle]="{borderColor: borderColor}"
         [ngClass]="{
         'MessageDesignBSmall-container-visible': visible,
         'MessageDesignBSmall-container-useFullWidth': useFullWidth
         }">
      @if (severity === MessageSeverity.ERROR) {
        <fa-icon class="error"
          [icon]="['fas', 'exclamation-circle']">
        </fa-icon>
      }
      @if (severity === MessageSeverity.SUCCESS) {
        <fa-icon class="success"
          [icon]="['fas', 'circle-check']">
        </fa-icon>
      }
      <div class="BasisGrotesqueProRegular FontSize_Rem_0_875 LineHeight_Rem_1_125 CP_design-b-blue-black">
        {{ messageText }}
      </div>
      <fa-icon [icon]="['fas', 'times']"
        (click)="onMsgHide()"
        class="CP_pointer FontSize_Rem_1_25 CP_design-b-light-grey-blue-two">
      </fa-icon>
    </div>
    `,
    styleUrls: ['./message-design-b-small.component.scss'],
    imports: [NgStyle, NgClass, FaIconComponent]
})
export class MessageDesignBSmallComponent {

  MessageSeverity = MessageSeverity;

  @Input() visible: boolean;
  @Input() useFullWidth: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() severity: MessageSeverity = MessageSeverity.ERROR;
  @Input() messageText: string;

  constructor(
    private store: Store
  ) {
  }

  onMsgHide() {
    this.store.dispatch(new UserPasswordAction.ResetFailedState);
    this.visibleChange.next(false);
  }

  get borderColor(): string {
    switch (this.severity) {
      case MessageSeverity.SUCCESS:
        return '#50de92';
      case MessageSeverity.ERROR:
        return '#ff7078';
    }
  }

}
